const root = { root: true };
export default {
    openAlgorithmByIdAsync: async ({ dispatch, state, rootGetters }, { tree, treeLoaded = false }) => {
        dispatch("general/logEvent", 'openAlgorithmById', root);
        if (!treeLoaded) {
            if (!state.lastItemId || rootGetters['topics/item'].id != state.lastItemId) {
                state.lastItemId = rootGetters['topics/item'].id;
                state.inputs = {};
            }
            await dispatch('addNode', { level: 0, ...JSON.parse(tree) });
        }
    },
    openAlgorithmsByModuleAndName: async ({ dispatch, state }, { module, name, children = [], parent = null, args = null, models = null }) => {
        dispatch("general/logEvent", `openFlow_${module}_${name}`, root);
        state.inputs = {};
        state.models = {};
        if (!name) {
            name = children[0];
            children = children.slice(1);
        }
        if (models && models.length) {
            models.forEach((model) => {
                state.models[model] = args[model];
            });
        }
        let nodes = require(`@/algorithms/${module}.algorithms.js`)[name](children, args);
        if (parent) {
            nodes = parent(nodes, args);
        }
        await dispatch('addNode', { level: 0, ...nodes });
    },
    openAlgorithmsNodes: async ({ dispatch, state }, { nodes, args = null, models = null }) => {
        state.inputs = {};
        state.models = {};
        if (models && models.length) {
            models.forEach((model) => {
                state.models[model] = args[model];
            });
        }
        await dispatch('addNode', { level: 0, ...nodes });
    },
    clearNodesModelsAndInputs({ state }) {
        state.nodes = [];
        state.models = {};
        state.inputs = {};
    },
    sliceNodes: async ({ state }, level) => {
        state.nodes = state.nodes.slice(0, level);
    },
    addNode: async ({ state, dispatch }, node) => {
        if (!!node) {
            if (typeof node.level !== 'number') {
                throw new Error();
            }
            await dispatch('sliceNodes', node.level);
            state.nodes.push(node);
        }
    },
    nextNode: async ({ state, dispatch }, { node, level }) => {
        if (!!node.child) {
            dispatch('addNode', { level: level + 1, ...node.child });
        } else {
            state.flowEndTrigger = new Date().getTime();
        }
    }
}